module.exports = __webpack_public_path__ + "img/icon-apple.f2f55d16.svg";